import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.SET_SELECTED](state, pageId) {
    Vue.set(state, 'selectedStorePageId', pageId);
  },

  [types.SET_PAGES](state, pageList) {
    Vue.set(state, 'storePageList', pageList);
  },

  [types.ADD_PAGES](state, pageList) {
    state.storePageList.push(...pageList);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/store-pages/store/mutations.js